<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <div v-else>
      <div
        class="profilebg"
        :style="{
          'background-image':
            'url(' +
            (data.painter_info.profile_cover
              ? data.painter_info.profile_cover
              : require('../../assets/bluebg.jpg')) +
            ')',
        }"
      >
        <div style="position: absolute; right: 10px; top: 10px">
          <v-btn
            dark
            :loading="imgCoverLoading"
            @click="$refs.uploadCover.onClickUploadFile()"
            icon
            small
          >
            <v-icon small style="color: white">mdi-square-edit-outline</v-icon>
          </v-btn>
        </div>
        <div>
          <div class="text-center pt-7 Kanit">
            <div
              style="
                position: relative;
                height: 125px;
                width: 125px;
                margin-left: auto;
                margin-right: auto;
              "
            >
              <img class="profileimg" :src="data.painter_info.profile_pic" />

              <div
                v-if="imgLoading"
                style="
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                "
              >
                <v-progress-circular
                  indeterminate
                  color="white"
                ></v-progress-circular>
              </div>
              <v-btn
                @click="$refs.uploadImg.onClickUploadFile()"
                class="editbutton"
                fab
                x-small
                color="primary"
              >
                <v-icon>mdi-square-edit-outline</v-icon>
              </v-btn>
            </div>
            <div class="mt-3">
              <p style="margin-bottom: 3px; font-size: 24px; color: white">
                {{ data.painter_info.name }}
              </p>
              <div>
                <div v-if="data.role.includes('ช่าง')">
                  <v-chip small>
                    <v-icon style="color: rgb(9 76 197)"
                      >mdi-format-paint</v-icon
                    >ช่างทาสี
                  </v-chip>
                </div>
                <div v-if="data.role.includes('ร้านค้า')">
                  <v-chip small>
                    <v-icon style="color: #d08600">mdi-store</v-icon>ร้านค้า
                  </v-chip>
                </div>
                <div v-if="data.role.includes('สถาปนิก')">
                  <v-chip small>
                    <v-icon style="color: rgb(0 156 84)">mdi-set-square</v-icon
                    >สถาปนิก
                  </v-chip>
                </div>
                <div v-if="data.role.includes('เจ้าของบ้าน')">
                  <v-chip small>
                    <v-icon style="color: rgb(197 9 9)">home</v-icon>เจ้าของบ้าน
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
          <div v-show="false">
            <uploadfile
              @startImgloading="startImgloading"
              ref="uploadImg"
              @input="onChangeImage"
              v-model="data.painter_info.profile_pic"
            ></uploadfile>
            <uploadfile
              @startImgloading="startImgCoverloading"
              ref="uploadCover"
              @input="onChangeCoverImage"
              v-model="data.painter_info.profile_cover"
            ></uploadfile>
          </div>
        </div>
        <div class="radiusfake"></div>
      </div>
      <div class="contentpad Kanit">
        <v-container style="position: relative; top: -17px" class="px-9 pt-0">
          <v-list dense>
            <template>
              <v-list-item @click="activeMain = !activeMain">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: #f5c644"
                          >mdi-format-list-checkbox</v-icon
                        >
                      </span>
                      <span class="painterfont">สถานะงาน</span>
                    </div>
                    <div>
                      <v-icon v-if="activeMain">mdi-chevron-down</v-icon>
                      <v-icon v-else>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <div v-if="activeMain">
                <div
                  style="
                    display: flex;
                    justify-content: space-evenly;
                    margin-top: 30px;
                    margin-bottom: 15px;
                  "
                >
                  <div
                    @click="
                      showOrdersDialog('waiting', data.orderstatus.request_job)
                    "
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.request_job
                              ? '#0a4ea2'
                              : 'darkgrey'
                          }`"
                          class="iconfontsize"
                          >mdi-text-box-remove-outline</v-icon
                        >
                        <div
                          v-if="data.orderstatus.request_job"
                          class="numbericon"
                        >
                          <div>{{ data.orderstatus.request_job }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center fontsizebig"
                      :style="`color: ${
                        data.orderstatus.request_job ? '#0a4ea2' : 'darkgrey'
                      }`"
                    >
                      ไม่กดรับงาน
                    </div>
                  </div>
                  <div
                    @click="
                      showOrdersDialog('accepted', data.orderstatus.contact)
                    "
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.contact ? '#0a4ea2' : 'darkgrey'
                          }`"
                          class="iconfontsize"
                          >mdi-text-box-check-outline</v-icon
                        >
                        <div v-if="data.orderstatus.contact" class="numbericon">
                          <div>{{ data.orderstatus.contact }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center fontsizebig"
                      :style="`color: ${
                        data.orderstatus.contact ? '#0a4ea2' : 'darkgrey'
                      }`"
                    >
                      กดรับงาน
                    </div>
                  </div>
                  <div
                    @click="
                      showOrdersDialog(
                        'waitingconfirm',
                        data.orderstatus.waiting_for_accept
                      )
                    "
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.waiting_for_accept
                              ? '#0a4ea2'
                              : 'darkgrey'
                          }`"
                          class="iconfontsize"
                          >mdi-checkbox-marked-circle-outline</v-icon
                        >
                        <div
                          v-if="data.orderstatus.waiting_for_accept"
                          class="numbericon"
                        >
                          <div>{{ data.orderstatus.waiting_for_accept }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center fontsizebig"
                      :style="`color: ${
                        data.orderstatus.waiting_for_accept
                          ? '#0a4ea2'
                          : 'darkgrey'
                      }`"
                    >
                      รอยืนยันเริ่มงาน
                    </div>
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: space-evenly;
                    margin-bottom: 25px;
                  "
                >
                  <div
                    @click="
                      showOrdersDialog(
                        'billconfirm',
                        data.orderstatus.waiting_upload_bill
                      )
                    "
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.waiting_upload_bill
                              ? '#0a4ea2'
                              : 'darkgrey'
                          }`"
                          class="iconfontsize"
                          >mdi-text-box-search-outline</v-icon
                        >
                        <div
                          v-if="data.orderstatus.waiting_upload_bill"
                          class="numbericon"
                        >
                          <div>{{ data.orderstatus.waiting_upload_bill }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center fontsizebig"
                      :style="`color: ${
                        data.orderstatus.waiting_upload_bill
                          ? '#0a4ea2'
                          : 'darkgrey'
                      }`"
                    >
                      รอยืนยันบิล
                    </div>
                  </div>
                  <div
                    @click="
                      showOrdersDialog(
                        'waitingreview',
                        data.orderstatus.waiting_for_review
                      )
                    "
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.waiting_for_review
                              ? '#0a4ea2'
                              : 'darkgrey'
                          }`"
                          class="iconfontsize"
                          >mdi-account-clock-outline</v-icon
                        >
                        <div
                          v-if="data.orderstatus.waiting_for_review"
                          class="numbericon"
                        >
                          <div>{{ data.orderstatus.waiting_for_review }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center fontsizebig"
                      :style="`color: ${
                        data.orderstatus.waiting_for_review
                          ? '#0a4ea2'
                          : 'darkgrey'
                      }`"
                    >
                      รอการรีวิว
                    </div>
                  </div>
                  <div
                    @click="
                      showOrdersDialog(
                        'customerreview',
                        data.orderstatus.review
                      )
                    "
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.review ? '#0a4ea2' : 'darkgrey'
                          }`"
                          class="iconfontsize"
                          >mdi-star-outline</v-icon
                        >
                        <div v-if="data.orderstatus.review" class="numbericon">
                          <div>{{ data.orderstatus.review }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center fontsizebig"
                      :style="`color: ${
                        data.orderstatus.review ? '#0a4ea2' : 'darkgrey'
                      }`"
                    >
                      ได้รับการรีวิว
                    </div>
                  </div>
                </div>
              </div>

              <v-list-item
                @click="
                  showOrdersDialog('updateprogress', data.orderstatus.contact)
                "
              >
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon
                          :style="
                            data.orderstatus.contact
                              ? ''
                              : 'color: rgb(179 179 179)'
                          "
                          class="iconmenu"
                          style="color: #73da73"
                          >mdi-progress-check</v-icon
                        >
                      </span>
                      <span
                        class="painterfont"
                        :style="
                          data.orderstatus.contact
                            ? ''
                            : 'color: rgb(179 179 179)'
                        "
                        >อัพเดทงานลูกค้า</span
                      >
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="
                  showOrdersDialog('cancelled', data.orderstatus.cancelled)
                "
              >
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon
                          class="iconmenu"
                          style="color: #da0f0f"
                          :style="
                            data.orderstatus.cancelled
                              ? ''
                              : 'color: rgb(179 179 179)'
                          "
                          >mdi-close-circle</v-icon
                        >
                      </span>
                      <span
                        :style="
                          data.orderstatus.cancelled
                            ? ''
                            : 'color: rgb(179 179 179)'
                        "
                        class="painterfont"
                        >งานถูกยกเลิก</span
                      >
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="changeView('DealerAddress')">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: green"
                          >mdi-home-map-marker</v-icon
                        >
                      </span>
                      <span class="painterfont">ที่อยู่ของฉัน</span>
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: rgb(179 179 179)"
                          >mdi-bell-outline</v-icon
                        >
                      </span>
                      <span class="painterfont" style="color: rgb(179 179 179)"
                        >แจ้งเตือน</span
                      >
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="showOrdersDialog('updateprofile', 1)">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: rgb(147 235 255)"
                          >mdi-cloud-upload-outline</v-icon
                        >
                      </span>
                      <span class="painterfont">อัพเดทผลงาน</span>
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: rgb(179 179 179)"
                          >mdi-history</v-icon
                        >
                      </span>
                      <span class="painterfont" style="color: rgb(179 179 179)"
                        >ประวัติการใช้งาน</span
                      >
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="changeView('ForgetPassword')">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: #05a3ff"
                          >mdi-shield-key-outline</v-icon
                        >
                      </span>
                      <span class="painterfont"
                        >รหัสผ่าน / เปลี่ยนรหัสผ่าน</span
                      >
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="logout">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: black"
                          >mdi-logout</v-icon
                        >
                      </span>
                      <span class="painterfont">ออกจากระบบ</span>
                    </div>
                    <div style="color: darkgrey">
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-container>
      </div>
      <div>
        <v-dialog v-model="showorders" persistent fullscreen>
          <v-card>
            <v-card-text v-if="showorders">
              <div class="text-right pa-3 pr-0">
                <v-btn
                  @click="
                    showorders = false;
                    active = '';
                  "
                  icon
                  small
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <div v-if="active == 'waiting'">
                <WaitingJob v-model="data"></WaitingJob>
              </div>
              <div v-else-if="active == 'waitingconfirm'">
                <WaitingConfirmJob v-model="data"></WaitingConfirmJob>
              </div>
              <div v-else-if="active == 'accepted'">
                <AcceptedJob v-model="data"></AcceptedJob>
              </div>
              <div v-else-if="active == 'cancelled'">
                <CancelledJob v-model="data"></CancelledJob>
              </div>
              <div v-else-if="active == 'customerreview'">
                <CustomerReview v-model="data"></CustomerReview>
              </div>
              <div v-else-if="active == 'billconfirm'">
                <BillConfirm v-model="data"></BillConfirm>
              </div>
              <div v-else-if="active == 'updateprofile'">
                <UpdateProfile v-model="data"></UpdateProfile>
              </div>
              <div v-else-if="active == 'waitingreview'">
                <WaitingReviewJob v-model="data"></WaitingReviewJob>
              </div>
              <div v-else-if="active == 'updateprogress'">
                <UpdateProgress v-model="data"></UpdateProgress>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";
import uploadfile from "@/components/UploadSingleFile.vue";
import WaitingJob from "./WaitingJob.vue";
import AcceptedJob from "./AcceptedJob.vue";
import CancelledJob from "./CancelledJob.vue";
import CustomerReview from "./CustomerReview.vue";
import WaitingConfirmJob from "./WaitingConfirmJob.vue";
import BillConfirm from "./BillConfirm.vue";
import UpdateProfile from "./UpdateProfile.vue";
import UpdateProgress from "./UpdateProgress.vue";
import WaitingReviewJob from "./WaitingReviewJob.vue";
export default {
  data() {
    return {
      imgCoverLoading: false,
      loading: true,
      showorders: false,
      activeMain: true,
      active: "",
      imgLoading: false,
    };
  },
  components: {
    Loading,
    uploadfile,
    WaitingJob,
    AcceptedJob,
    CancelledJob,
    CustomerReview,
    WaitingConfirmJob,
    BillConfirm,
    UpdateProfile,
    UpdateProgress,
    WaitingReviewJob,
  },
  computed: {
    data() {
      return this.$store.state.show;
    },
    profile() {
      return this.$store.state.profile;
    },
    query() {
      return this.$store.state.query;
    },
    orderlist() {
      if (this.active) {
        return this.data.orderlist.filter((el) => el.status == this.active);
      } else return [];
    },
  },
  async mounted() {
    await this.checkLoginStatus();
    // if (!this.data) {
    await this.getCustomerInfo();
    // }
    if (this.query.open == "waitingjob") {
      this.showOrdersDialog("waiting");
    } else if (this.query.open == "acceptedjob") {
      this.showOrdersDialog("accepted");
    } else if (this.query.open == "updatejob") {
      this.showOrdersDialog("updateprogress");
    }
    this.loading = false;
    // this.showorders = true;
    // this.active = "";
  },
  methods: {
    startImgloading() {
      this.imgLoading = !this.imgLoading;
    },
    startImgCoverloading() {
      this.imgCoverLoading = !this.imgCoverLoading;
    },
    onChangeImage() {
      this.imgLoading = true;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        profile_upload: this.data.painter_info.profile_pic,
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toapainteruploadprofile",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          }
          this.imgLoading = false;
        });
    },
    onChangeCoverImage() {
      this.imgCoverLoading = true;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        profile_cover: this.data.painter_info.profile_cover,
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toauploadprofilecover",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          }
          this.imgCoverLoading = false;
        });
    },
    showOrdersDialog(type, countnumber = 1) {
      if (countnumber) {
        this.active = type;
        this.showorders = true;
      }
    },
    changeView(view) {
      this.$store.state.redirect = "PainterProfile";
      this.query.view = view;
    },
    checkLoginStatus() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckstatuslogincustomer",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 400) {
              this.$store.state.redirect = "CustomerProfile";
              this.query.view = "Agreement";
              resolve();
            } else {
              resolve();
            }
          });
      });
    },
    logout() {
      var vm = this;
      vm.$swal.fire({
        icon: "question",
        text: "ต้องการออกจากระบบใช่หรือไม่?",
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return new Promise((resolve, reject) => {
            var data = {
              userid: this.$store.state.userid,
              apptype: this.query.apptype,
              pageid: vm.query.pageid,
            };
            axios
              .put(
                "https://communitybotbyzwizai.herokuapp.com/toalogoutusers",
                data,
                {
                  headers: { AUTHORIZATION: "Bearer xxx xxx" },
                }
              )
              .then(async (response) => {
                if (response.data && response.data.responsecode == 400) {
                  await this.$swal.fire({
                    icon: "error",
                    text: response.data.reason,
                  });
                  return;
                } else if (response.data.responsecode == 200) {
                  vm.$store.state.redirect = "CustomerProfile";
                  vm.query.view = "Login";
                  resolve();
                }
              });
          });
        },
      });
    },
    getCustomerInfo() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toapainterpersonalinfo",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: vm.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              vm.$store.state.show = response.data.data[0];
              resolve();
            } else {
              vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            }
          });
      });
    },
  },
};
</script>
<style scoped>
.fontsizebig {
  font-size: 12px;
}
.iconfontsize {
  font-size: 30px;
}
.painterfont {
  color: #0a4ea2;
  font-size: 13px;
}
.iconmenu {
  font-size: 23px !important;
}
.numbericon {
  font-size: 11px;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  position: absolute;
  justify-content: center;
  border-radius: 99px;
  color: white;
  background-color: #d10a0a;
  top: -6px;
  left: -7px;
}
</style>